import React from 'react'
import { observer } from 'mobx-react'
import AccessDeniedView from 'components/AccessDeniedView'
import Button from 'components/Button'
import { useDocumentTitle } from 'hooks/document-title'
import { useActivation } from 'hooks/mobx-hooks'
import styles from './ClientUserManagement.sass'
import { ClientUserManagementViewModel } from './ClientUserManagementViewModel'
import ClientUserManagementTable from 'client-user-management/components/ClientUserManagementTable'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
} from 'components/StickyViewHeader'
import { ViewHeading } from 'components/ViewHeading'
import { ClientInvitationDialog } from 'client-user-management/views/ClientInvitationDialog'

interface ClientUserManagementProps {
  vm: ClientUserManagementViewModel
}

export default observer(({ vm }: ClientUserManagementProps) => {
  useDocumentTitle('User Management')
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  useActivation(vm)

  return vm.canAccessClientUserManagement ? (
    <div ref={scrollRef} className={styles.root}>
      <StickyViewHeader scrollOffset={scrollOffset}>
        <StickyViewHeaderMain>
          <ViewHeading primaryText="Client Management" secondaryText="" />
        </StickyViewHeaderMain>
        {vm.canInviteClients && (
          <StickyViewHeaderExtras>
            <Button
              type="secondary"
              data-test="client-management-invite-button"
              onClick={() => vm.clientInvitationVM.show()}
            >
              Invite
            </Button>
          </StickyViewHeaderExtras>
        )}
      </StickyViewHeader>
      <ClientUserManagementTable vm={vm} />
      <ClientInvitationDialog vm={vm.clientInvitationVM} />
    </div>
  ) : (
    <AccessDeniedView data-test="user-management-access-denied" />
  )
})
